<template>
    <div>
        <div class="fabs">
            <div v-if="chatStatusVisible" :class="{'is-visible': chatStatusVisible}" class="chat">
                <div class="chat_header" :class="`bg-${color.primary}`">
                    <div class="chat_option">
                        <div class="header_img">
                            <img src="@img/support.png" />
                        </div>
                        <span id="chat_head">{{$t("support.chat.title")}}</span>
                        <br />
                        <span class="agent">{{$t("support.chat.attendant")}}</span>
                    </div>
                </div>
                <div v-if="chatStatusVisible" id="mainMessages" class="chat_conversion chat_converse">
                    <template v-for="message in messages" :key="message.id">
                        <div>
                            <span class="chat_msg_item"
                                :class="{'chat_msg_item_admin' : message.user.id != userRoles.user.id,'chat_msg_item_user': message.user.id == userRoles.user.id}">
                                {{message.content}}
                            </span>
                            <div class="status"
                                :class="{'fl-left' :  message.user.id != userRoles.user.id,'fl-right': message.user.id == userRoles.user.id}">
                                {{message.updated_at}}
                            </div>
                        </div>
                    </template>
                </div>
                <div class="fab_field">
                    <textarea
                        id="chatSend"
                        v-model="textAreaChat"
                        name="chat_message"
                        @keyup.enter="e => {e.shiftKey ? null : sendMessage()}"
                        :placeholder="$t('support.chat.send_placeholder')"
                        class="chat_field chat_message">
                    </textarea>
                    <a class="sendButton" @click="addMessage()">
                        <i class="mdi mdi-send"></i>
                    </a>
                </div>
            </div>
            <a id="prime" class="fab" @click="toggleFab" :class="`bg-${color.primary}`">
                <i class="fa"
                    :class="{'fa-comment-dots': !chatStatusVisible,'fa-times is-active is-visible': chatStatusVisible}"></i>
            </a>
        </div>
    </div>
</template>


<script>
import BaseButton from '../argon/components/BaseButton';

export default {
    name: 'Chat',
    components: {
        BaseButton,
    },
    props: {
        roomId: String,
        userRoles: Object,
        color: {
            type: Object,
        },
    },
    data() {
        return {
            chatStatusVisible: false,
            hide: 0,
            me: true,
            messages: [], // Corrigir aqui para "messages"
            mainMessages: null,
            ws: null,
            textAreaChat: '',
        };
    },
    methods: {
        toggleFab() {
            this.chatStatusVisible = !this.chatStatusVisible;
            if (this.chatStatusVisible && this.roomId) {
                this.messages = [];
                this.wsServer();
            }
        },
        chatScrollDown() {
            setTimeout(() => {
                this.mainMessages = document.getElementById('mainMessages');
                if (this.mainMessages) {
                    this.mainMessages.scrollTop = this.mainMessages.scrollHeight;
                }
            }, 100);
        },
        joinRoom() {
            const joinPayload = {
                service: 'Chat',
                action: 'joinRoom',
                params: {
                    service: 'Chat',
                    moderate: 0,
                    room_id: this.roomId,
                    user_id: this.userRoles.user.id,
                    history: 1,
                    name: this.userRoles.user.name,
                },
            };
            this.ws.send(JSON.stringify(joinPayload));
        },
        leaveRoom() {
            const leavePayload = {
                service: 'Chat',
                action: 'leaveRoom',
                params: {
                    service: 'Chat',
                    room_id: this.roomId,
                    user_id: this.userRoles.user.id,
                },
            };
            this.ws.send(JSON.stringify(leavePayload));
        },
        sendMessage() {
            try {
                this.textAreaChat = /\S/.test(this.textAreaChat) ? this.textAreaChat : '';
                this.addMessage();
                this.textAreaChat = '';
            } catch (error) {
                console.log('Erro ao enviar mensagem');
                console.log(error);
            }
        },
        addMessage() {
            if (this.roomId && this.userRoles.user.id && this.textAreaChat !== '') {
                const messagePayload = {
                    service: 'Chat',
                    action: 'sendMessage',
                    params: {
                        service: 'Chat',
                        moderate: 0,
                        room_id: this.roomId,
                        user_id: this.userRoles.user.id,
                        content: this.textAreaChat,
                    },
                };
                this.ws.send(JSON.stringify(messagePayload));
                this.textAreaChat = '';
            } else {
                alert(this.$t('support.chat.err_send_message'));
            }
        },
        wsServer() {
            const { host } = location;
            this.ws = new WebSocket(`wss://${host}/ws?service=Chat&room_id=${this.roomId}&user_id=${this.userRoles.user.id}`);
            this.ws.onopen = (event) => {
                this.joinRoom();
            };
            this.ws.onmessage = (event) => {
                if (event.data) {
                    try {
                        const response = JSON.parse(event.data);
                        switch (response.action) {
                        case 'join':
                            this.messages = response.messages;
                            break;
                        case 'send':
                            this.messages.push(response.message);
                            break;
                        case 'leave':
                            break;
                        default:
                            break;
                        }
                    } catch (e) {
                        console.error('ONMESSAGE::', e);
                    }
                }
                this.chatScrollDown();
            };

            this.ws.onerror = (event) => {
                console.log('LOG3', 'Server disconnected', event.data);
            };

            this.ws.onclose = (event) => {
                this.wsServer();
            };
        },
    },
};
</script>

<style scoped>
.fl-left {
    float: left;
    margin-left: 15px;
}

.fl-right {
    float: right;
    margin-right: 15px;
}

.hidde ul li {
    list-style: none;
}

.fabs {
    bottom: 0;
    position: fixed;
    margin: 1em;
    right: 0;
    z-index: 998;
}

.fab {
    display: block;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    text-align: center;
    color: #f0f0f0;
    margin: 25px auto 0;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.14), 0 4px 8px rgba(0, 0, 0, 0.28);
    cursor: pointer;
    -webkit-transition: all 0.1s ease-out;
    transition: all 0.1s ease-out;
    position: relative;
    z-index: 998;
    overflow: hidden;
    background: #42a5f5;
}

.sendButton {
    cursor: pointer;
    font-size: 2em;
    float: right;
    padding: 15px;
    text-align: center !important;
    z-index: 9999;
}

.fab>i {
    color: white;
    font-size: 2em;
    line-height: 55px;
    -webkit-transition: all 0.2s ease-out;
    -webkit-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
}

.fab:not(:last-child) {
    width: 0;
    height: 0;
    margin: 20px auto 0;
    opacity: 0;
    visibility: hidden;
    line-height: 40px;
}

.fab:not(:last-child)>i {
    font-size: 1.4em;
    line-height: 40px;
}

.fab:not(:last-child).is-visible {
    width: 40px;
    height: 40px;
    margin: 15px auto 10;
    opacity: 1;
    visibility: visible;
}

.fab:nth-last-child(1) {
    -webkit-transition-delay: 25ms;
    transition-delay: 25ms;
}

.fab:not(:last-child):nth-last-child(2) {
    -webkit-transition-delay: 20ms;
    transition-delay: 20ms;
}

.fab:not(:last-child):nth-last-child(3) {
    -webkit-transition-delay: 40ms;
    transition-delay: 40ms;
}

.fab:not(:last-child):nth-last-child(4) {
    -webkit-transition-delay: 60ms;
    transition-delay: 60ms;
}

.fab:not(:last-child):nth-last-child(5) {
    -webkit-transition-delay: 80ms;
    transition-delay: 80ms;
}

.chat {
    position: fixed;
    right: 85px;
    bottom: 20px;
    width: 400px;
    font-size: 12px;
    line-height: 22px;
    font-family: "Roboto";
    font-weight: 500;
    opacity: 0;
    box-shadow: 1px 1px 100px 2px rgba(0, 0, 0, 0.22);
    border-radius: 10px;
    -webkit-transition: all 0.2s ease-out;
    -webkit-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
}

.chat_header {
    /* margin: 10px; */
    font-size: 13px;
    font-family: "Roboto";
    font-weight: 500;
    color: #f3f3f3;
    height: 55px;
    background: #42a5f5;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    padding-top: 8px;
}

.chat_header .span {
    float: right;
}

.chat.is-visible {
    opacity: 1;
    -webkit-animation: zoomIn 0.2s cubic-bezier(0.42, 0, 0.58, 1);
    animation: zoomIn 0.2s cubic-bezier(0.42, 0, 0.58, 1);
}

.is-hide {
    opacity: 0;
}

.chat_option {
    float: left;
    font-size: 15px;
    list-style: none;
    position: relative;
    height: 100%;
    width: 100%;
    text-align: relative;
    margin-right: 10px;
    letter-spacing: 0.5px;
    font-weight: 400;
}

.chat_option img {
    background: #ffff;
    border-radius: 50%;
    padding: 5px;
    width: 55px;
    float: left;
    margin: -30px 20px 10px 20px;
}

.change_img img {
    width: 35px;
    margin: 0px 20px 0px 20px;
}

.chat_option .agent {
    font-size: 12px;
    font-weight: 300;
}

.chat_option .online {
    opacity: 0.4;
    font-size: 11px;
    font-weight: 300;
}

.chat_color {
    display: block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin: 10px;
    float: left;
}

.chat_field {
    position: relative;
    margin: 5px 0 5px 0;
    width: 50%;
    font-family: "Roboto";
    font-size: 12px;
    line-height: 1.5;
    font-weight: 500;
    color: #4b4b4b;
    -webkit-font-smoothing: antialiased;
    border: none;
    outline: none;
    display: inline-block;
}

.chat_field.chat_message {
    height: 90px;
    resize: none;
    font-size: 13px;
    font-weight: 400;
}

.fab_field {
    width: 100%;
    display: inline-block;
    text-align: center;
    background: #fff;
    border-top: 1px solid #eee;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
}

.fab_field a {
    display: inline-block;
    text-align: center;
}

#fab_camera {
    float: left;
    background: rgba(0, 0, 0, 0);
}

#fab_send {
    float: right;
    background: rgba(0, 0, 0, 0);
}

.fab_field .fab {
    width: 35px;
    height: 35px;
    box-shadow: none;
    margin: 5px;
}

.fab_field .fab>i {
    font-size: 1.6em;
    line-height: 35px;
    color: #bbb;
}

.fab_field .fab>i:hover {
    color: #42a5f5;
}

.chat_converse {
    position: relative;
    background: #fff;
    height: 350px;
    min-height: 0;
    font-size: 12px;
    line-height: 18px;
    overflow-y: auto;
    width: 100%;
    float: right;
    padding-bottom: 30px;
}

.chat .chat_converse .chat_msg_item {
    position: relative;
    margin: 8px 0 8px 0;
    padding: 8px 10px;
    max-width: 60%;
    display: block;
    word-wrap: break-word;
    border-radius: 3px;
    -webkit-animation: zoomIn 0.5s cubic-bezier(0.42, 0, 0.58, 1);
    animation: zoomIn 0.5s cubic-bezier(0.42, 0, 0.58, 1);
    clear: both;
    z-index: 2;
}

.status {
    clear: both;
    font-size: 11px;
    opacity: 0.3;
}

.chat .chat_converse .chat_msg_item .chat_avatar {
    position: absolute;
    top: 0;
}

.chat .chat_converse .chat_msg_item.chat_msg_item_admin .chat_avatar {
    left: -52px;
    background: rgba(0, 0, 0, 0.03);
}

.chat .chat_converse .chat_msg_item.chat_msg_item_user .chat_avatar {
    right: -52px;
    background: rgba(0, 0, 0, 0.6);
}

.chat .chat_converse .chat_msg_item .chat_avatar,
.chat_avatar img {
    width: 40px;
    height: 40px;
    text-align: center;
    border-radius: 50%;
}

.chat .chat_converse .chat_msg_item.chat_msg_item_admin {
    margin-left: 15px;
    float: left;
    background: rgba(0, 0, 0, 0.03);
    color: #666;
}

.chat .chat_converse .chat_msg_item.chat_msg_item_user {
    margin-right: 15px;
    float: right;
    background: #42a5f5;
    color: #eceff1;
}

.chat .chat_converse .chat_msg_item.chat_msg_item_admin:before {
    content: "";
    position: absolute;
    top: 15px;
    left: -12px;
    z-index: 998;
    border: 6px solid transparent;
    border-right-color: rgba(255, 255, 255, 0.4);
}

.chat_form .get-notified label {
    color: #077ad6;
    font-weight: 600;
    font-size: 11px;
}

input {
    position: relative;
    width: 90%;
    font-family: "Roboto";
    font-size: 12px;
    line-height: 20px;
    font-weight: 500;
    color: #4b4b4b;
    -webkit-font-smoothing: antialiased;
    outline: none;
    background: #fff;
    display: inline-block;
    resize: none;
    padding: 5px;
    border-radius: 3px;
}

.chat_form .get-notified input {
    margin: 2px 0 0 0;
    border: 1px solid #83c76d;
}

.chat_form .get-notified i {
    background: #83c76d;
    width: 30px;
    height: 32px;
    font-size: 18px;
    color: #fff;
    line-height: 30px;
    font-weight: 600;
    text-align: center;
    margin: 2px 0 0 -30px;
    position: absolute;
    border-radius: 3px;
}

.chat_form .message_form {
    margin: 10px 0 0 0;
}

.chat_form .message_form input {
    margin: 5px 0 5px 0;
    border: 1px solid #e0e0e0;
}

.chat_form .message_form textarea {
    margin: 5px 0 5px 0;
    border: 1px solid #e0e0e0;
    position: relative;
    width: 90%;
    font-family: "Roboto";
    font-size: 12px;
    line-height: 20px;
    font-weight: 500;
    color: #4b4b4b;
    outline: none;
    background: #fff;
    display: inline-block;
    resize: none;
    padding: 5px;
    border-radius: 3px;
}

.chat_form .message_form button {
    margin: 5px 0 5px 0;
    border: 1px solid #e0e0e0;
    position: relative;
    width: 95%;
    font-family: "Roboto";
    font-size: 12px;
    line-height: 20px;
    font-weight: 500;
    color: #fff;
    -webkit-font-smoothing: antialiased;
    outline: none;
    background: #fff;
    display: inline-block;
    resize: none;
    padding: 5px;
    border-radius: 3px;
    background: #83c76d;
    cursor: pointer;
}

strong.chat_time {
    padding: 0 1px 1px 0;
    font-weight: 500;
    font-size: 8px;
    display: block;
}

/*Chatbox scrollbar*/

::-webkit-scrollbar {
    width: 6px;
}

::-webkit-scrollbar-track {
    border-radius: 0;
}

::-webkit-scrollbar-thumb {
    margin: 2px;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.2);
}

/*Element state*/

.is-active {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
    -webkit-transition: all 1s ease-in-out;
    transition: all 1s ease-in-out;
}

.is-float {
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.16), 0 6px 12px rgba(0, 0, 0, 0.32);
}

/*Animation*/

@-webkit-keyframes zoomIn {
    0% {
        -webkit-transform: scale(0);
        transform: scale(0);
        opacity: 0;
    }

    100% {
        -webkit-transform: scale(1);
        transform: scale(1);
        opacity: 1;
    }
}

@keyframes zoomIn {
    0% {
        -webkit-transform: scale(0);
        transform: scale(0);
        opacity: 0;
    }

    100% {
        -webkit-transform: scale(1);
        transform: scale(1);
        opacity: 1;
    }
}

@-webkit-keyframes load {
    0% {
        -webkit-transform: scale(0);
        transform: scale(0);
        opacity: 0;
    }

    50% {
        -webkit-transform: scale(1.5);
        transform: scale(1.5);
        opacity: 1;
    }

    100% {
        -webkit-transform: scale(1);
        transform: scale(1);
        opacity: 0;
    }
}

@keyframes load {
    0% {
        -webkit-transform: scale(0);
        transform: scale(0);
        opacity: 0;
    }

    50% {
        -webkit-transform: scale(1.5);
        transform: scale(1.5);
        opacity: 1;
    }

    100% {
        -webkit-transform: scale(1);
        transform: scale(1);
        opacity: 0;
    }
}

/* SMARTPHONES PORTRAIT */

@media only screen and (min-width: 300px) {
    .chat {
        width: 250px;
    }
}

/* SMARTPHONES LANDSCAPE */

@media only screen and (min-width: 480px) {
    .chat {
        width: 300px;
    }

    .chat_field {
        width: 65%;
    }
}

/* TABLETS PORTRAIT */

@media only screen and (min-width: 768px) {
    .chat {
        width: 300px;
    }

    .chat_field {
        width: 65%;
    }
}

/* TABLET LANDSCAPE / DESKTOP */

@media only screen and (min-width: 1024px) {
    .chat {
        width: 300px;
    }

    .chat_field {
        width: 65%;
    }
}

/*Color Options*/

.blue .fab {
    background: #42a5f5;
    color: #fff;
}

.blue .chat {
    background: #42a5f5;
    color: #999;
}

/* Ripple */

.ink {
    display: block;
    position: absolute;
    background: rgba(38, 50, 56, 0.4);
    border-radius: 100%;
    -moz-transform: scale(0);
    -ms-transform: scale(0);
    -webkit-transform: scale(0);
    transform: scale(0);
}

/*animation effect*/

.ink.animate {
    -webkit-animation: ripple 0.5s ease-in-out;
    animation: ripple 0.5s ease-in-out;
}

@-webkit-keyframes ripple {

    100% {
        opacity: 0;
        -moz-transform: scale(5);
        -ms-transform: scale(5);
        webkit-transform: scale(5);
        -webkit-transform: scale(5);
        transform: scale(5);
    }
}

@keyframes ripple {

    100% {
        opacity: 0;
        -moz-transform: scale(5);
        -ms-transform: scale(5);
        webkit-transform: scale(5);
        -webkit-transform: scale(5);
        transform: scale(5);
    }
}

::-webkit-input-placeholder {
    color: #bbb;
}

:-ms-input-placeholder {
    color: #bbb;
}

::-moz-placeholder {
    color: #bbb;
}

:-moz-placeholder {
    color: #bbb;
}
</style>
